import React, { useEffect, useState } from 'react';
import { useDraggableY } from '@/hooks/useDraggableY';
import { cx } from '@/utils';
import { t } from '@lingui/macro';
import { motion } from 'framer-motion';
import { Tooltip } from 'react-tooltip';

import AccessibilityIconBrightness from '../Icons/AccessibilityIconBrightness';
import AccessibilityIconBrightnessMaxText from '../Icons/AccessibilityIconBrightnessMaxText';
import AccessibilityIconBrightnessMinText from '../Icons/AccessibilityIconBrightnessMinText';
import { useLayoutContext } from '../Layout/LayoutProvider/LayoutContext';
import { useAccessibilityContext } from '../Providers/AccessibilityProvider/AccessibilityContext';
import useAccesibilityActions from './hooks/useAccesibilityActions';
import WrapperGrayScale from './WrapperGrayScale';

const AccessibilityButtonMinimal = ({ isPreview }: { isPreview?: boolean }) => {
  const { position, handleMouseDown, isDrag } = useDraggableY();
  const [isVisible, setIsVisible] = useState(false);

  const {
    layout: { isGrayScaled, isHightContrast },
  } = useLayoutContext();

  const {
    storytellerEnabled,
    fontSize,
    isCursorBig,
    isDislexic,
    isHightlightLink,
    langTeller,
    languaje,
  } = useAccessibilityContext();

  useEffect(() => {
    const layoutParameterers = {
      isGrayScaled,
      isHightContrast,
    };
    localStorage.setItem('layoutParameters', JSON.stringify(layoutParameterers));
  }, [isGrayScaled, isHightContrast]);

  useEffect(() => {
    const parameters = {
      storytellerEnabled,
      fontSize,
      isCursorBig,
      isDislexic,
      isHightlightLink,
      langTeller,
      languaje,
    };

    localStorage.setItem('accessibilityParameters', JSON.stringify(parameters));
  }, [
    storytellerEnabled,
    fontSize,
    isCursorBig,
    isDislexic,
    isHightlightLink,
    langTeller,
    languaje,
  ]);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  useEffect(() => {
    toggleVisibility();
  }, []);

  const { changeSizeFontPlus, changeSizeFontMinus, toggleHightContrast } = useAccesibilityActions();

  return (
    <>
      <div
        className={cx('fixed end-0 top-[20%] z-[100]', { '!relative': isPreview })}
        style={{ top: position?.top }}
        onMouseDown={isPreview ? undefined : handleMouseDown}
      >
        <Tooltip
          style={{
            backgroundColor: 'white',
            color: '#222',
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.5)',
            marginLeft: '-15px',
          }}
          anchorSelect=".my-anchor-element"
          place="left"
        >
          {'Contraste'}
        </Tooltip>

        <Tooltip
          style={{
            backgroundColor: 'white',
            color: '#222',
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.5)',
            marginLeft: '-15px',
          }}
          anchorSelect=".my-anchor-element-1"
          place="left"
        >
          {'Disminuir texto'}
        </Tooltip>

        <Tooltip
          style={{
            backgroundColor: 'white',
            color: '#222',
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.5)',
            marginLeft: '-15px',
          }}
          anchorSelect=".my-anchor-element-2"
          place="left"
        >
          {'Aumentar texto'}
        </Tooltip>

        <WrapperGrayScale
          className={`relative flex flex-row transition-transform duration-300 ease-in-out ${'translate-x-0'}`}
        >
          <div className="flex flex-col gap-4 rounded-l-2xl bg-primary p-4 shadow-2xl">
            <a className="my-anchor-element">
              <motion.div whileHover={{ scale: 1.2 }}>
                <AccessibilityIconBrightness
                  onClick={() => !isDrag && toggleHightContrast()}
                  className="cursor-pointer fill-primary"
                />
              </motion.div>
            </a>
            <a className="my-anchor-element-1">
              <motion.div whileHover={{ scale: 1.2 }}>
                <AccessibilityIconBrightnessMinText
                  onClick={() => !isDrag && changeSizeFontMinus()}
                  className="cursor-pointer fill-primary"
                />{' '}
              </motion.div>
            </a>
            <a className="my-anchor-element-2">
              <motion.div whileHover={{ scale: 1.2 }}>
                <AccessibilityIconBrightnessMaxText
                  onClick={() => !isDrag && changeSizeFontPlus()}
                  className="cursor-pointer fill-primary"
                />
              </motion.div>
            </a>
          </div>
        </WrapperGrayScale>
      </div>
    </>
  );
};

export default AccessibilityButtonMinimal;
